import script from "./ProductWorkarea.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProductWorkarea.vue?vue&type=script&setup=true&lang=ts"

import "./ProductWorkarea.scss?vue&type=style&index=0&id=38b6bd4f&scoped=true&lang=scss&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-38b6bd4f"]])

export default __exports__